module.exports = __webpack_public_path__ + "img/Line.0ff7ab3d.svg";